import { LogoutOutlined } from "@ant-design/icons";
import {
  Avatar,
  Badge,
  Button,
  Card,
  Col,
  Divider,
  Drawer,
  Image,
  Modal,
  Popconfirm,
  Popover,
  Steps,
  message
} from "antd";
import instaBadges from "assets/images/app/InstaProf_Icon.png";
import Calendar from "assets/images/app/calendar_icon.svg";
import CouponIcon from "assets/images/app/coupon_icon.svg";
import Gamification from "assets/images/app/gamification.svg";
import logo from "assets/images/app/header/logo.svg";
import Students from "assets/images/app/iam_student.svg";
import Onboarding from "assets/images/app/onboarding_icon.svg";
import instaBadgesRed from "assets/images/students/instaProfBadgeFalse.svg";
import { StatusCode, UserRoles } from "common/enums";
import Container from "components/container";
import MAA from "components/maa";
import Notification from "components/notifications/teacher";
import * as appRoutes from "config/routes.config";
import { FC, Fragment, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import LottieAnimation from "screens/teacher/components/LottieAnimation";
import MenuModal from "screens/teacher/components/menu";
import { toggleAppChat } from "store/AppChat/appChat";
import { setCheckClass, setCheckClassOrganism, setCorrectingLevel, setIsNewData, setUserTeachingOrganismClass } from "store/app/appSlice";
import {
  closePorteFeuilleDrawer__,
  closeProfileDrawer,
  logout,
  openPorteFeuilleDrawer__,
  openProfileDrawer,
  setCouponDrawer,
} from "store/auth/authSlice";
import { openChatDrawer } from "store/chat/mainSlice";
import { clearRoom } from "store/chat/roomSlice";
import { clearRooms } from "store/chat/roomsSlice";
import {
  ACTIVE_DRAWER_ALERT_INSTAPROF,
  ACTIVE_MODE_INSTAPROF,
  INIT_MODAL,
} from "store/notification";
import {
  useAcceptNotificationOfInstaProfMutation,
  useDeleteNotifByUserMutation,
  useGetNotifByUserQuery,
  useViewNotifByUserMutation,
} from "store/services/teacher/notification.services";
import logoMobile from "../../assets/images/albert/status/Very happy.svg";
import ArrowDown from "../../assets/images/app/arrow_bottom_down.svg";
import ArrowUp from "../../assets/images/app/arrow_top_up.svg";
import CalendarIcon from "../../assets/images/app/calendar_teacher_icon.svg";
import TeacherProfile from "../../assets/images/app/iam_teacher.svg";
import LogoutIcon from "../../assets/images/app/logout_icon.svg";
import Msg from "../../assets/images/app/messagerie.svg";
import MenuIcon from "../../assets/images/app/new_menu.svg";
import NavUser from "./NavUser";
import Classes from "./assets/images/classes.svg";
import Coeur from "./assets/images/coeur.svg";
import Dashboard from "./assets/images/dashboard.svg";
import InfoIcon from "./assets/images/info.svg";
import Maa from "./assets/images/maa.svg";
import PointIcon from "./assets/images/points.svg";
import AnimationData from "./assets/images/warning_animation.json";

import Contact from "assets/images/app/contact.svg";
import Content from "assets/images/app/contenu.svg";
import Aide from "assets/images/app/faq.svg";
import Wallet from "assets/images/app/wallet_paiement_icon.svg";
import MyClasses from "assets/images/icons/teacher_classes.svg";

import style from "./assets/user.header.module.css";

import { useGetOrganismRoomsQuery } from "store/services/teacher/classes.services";
import * as TEACHER_SERVICES from "../../api/services/teacher/teacher.services";
import WhenNotConnected from "./header";

const { Step } = Steps;

const User: FC = () => {
  //!HOOKS
  const { isLoggedIn } = useSelector((state) => state.auth);
  const { isFullscreen } = useSelector((state) => state.app);

  //!RETURN
  return (
    <div>
      {isLoggedIn && !isFullscreen && <WhenConnected />}
      {!isLoggedIn && <WhenNotConnected />}
    </div>
  );
};

/* type MenuProps = {
  isFullscreen?: boolean, 
}  */

interface CustomResponse {
  statusCode: number;
  message: string;
  data: any;
}

const WhenConnected: FC = () => {

  //!HOOKS
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user, currentStudentInstaProf } = useSelector((state) => state.auth);
  const { userHavingCalendar } = useSelector((state) => state.app);
  const { isNewData } = useSelector((state) => state.app);

  const popoverReportRef = useRef<HTMLDivElement>(null);
  const [visibleOptions, setVisibleOptions] = useState(false);
  const [seeProfile, setSeeProfile] = useState(false);
  const [wantDisconnect, setWantDisconnect] = useState(false);

  const { data: rooms, isLoading: isLoadingRooms, isError, refetch: refetchRooms } = useGetOrganismRoomsQuery(user?._id);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1151);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1151);
  };
  window.addEventListener('resize', handleResize);

  const { currentChat } = useSelector((state) => state.appChat);

  const {
    data: dataNotif,
    isLoading,
    refetch,
  } = useGetNotifByUserQuery(user._id);

  const { socket } = useSelector((state) => state.appChat);

  const [
    deleteNotifByUser,
    { data: deleteData, isLoading: isLoadingDelete, isSuccess },
  ] = useDeleteNotifByUserMutation();

  const [
    viewNotifByUser,
    { data: viewData, isLoading: isLoadingView, isSuccess: isSuccessView },
  ] = useViewNotifByUserMutation();

  const [
    acceptNotificationOfInstaProf,
    { data: acceptNotif, isSuccess: acceptNotifIsSucces },
  ] = useAcceptNotificationOfInstaProfMutation();

  //!STATE
  const [visible, setVisible] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [moneyDrawer, setMoneyDrawerOpen] = useState(false);
  const [notif, setMotif] = useState<any>([]);
  const [LoadingNotif, setLoadingNotif] = useState<boolean>(true);
  const [open, setOpen] = useState<boolean>(false);
  const [allDataInstaProf, setAllDataInstaProf] = useState<any>();

  const { isCorrectingLevel } = useSelector((state) => state.app);

  ///const [calendarAddeed, setCalendarAdded] = useState<boolean>(false);

  const [bookingCount, setBookingCount] = useState<number>(0);
  const [openMenu, setOpenMenu] = useState(false);

  //!FUNCTIONS
  const openPorteFeuilleDrawer = () => dispatch(openPorteFeuilleDrawer__());
  const openDrawer = () => dispatch(openProfileDrawer());
  const closeVideoModal = () => setShowVideoModal(false);
  const closeMoneyDrawer = () => setMoneyDrawerOpen(false);
  const openCouponsDrawer = () => dispatch(setCouponDrawer(true));

  const handleClickOutside = (event: MouseEvent) => {
    setTimeout(() => {
      if (popoverReportRef.current && !popoverReportRef.current.contains(event.target as Node)) {
        if (seeProfile || wantDisconnect) {
          console.log("Action selected!");
        } else {
          setVisibleOptions(false);
        }
      }
    }, 200);
  };

  const getBookingData = async () => {
    try {
      const response = await TEACHER_SERVICES.getBookingData(user?._id);
      if (response?.statusCode === StatusCode.OK) {
        if (response?.data) {
          setBookingCount(response?.data?.length);
        }
        else {
          setBookingCount(0);
        }
      }
    } catch (error: any) {
      console.error("Error fetching booking data:", error);
    } finally {
      dispatch(setIsNewData(false));
    }
  };

  useEffect(() => {
    if (user) {
      getBookingData();
    }
  }, [user]);

  useEffect(() => {
    if (isNewData) {
      getBookingData();
    }
  }, [isNewData]);

  useEffect(() => {
    if (rooms?.data?.length > 0) {
      dispatch(setUserTeachingOrganismClass(true));
    }
  }, [rooms]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [seeProfile, wantDisconnect]);

  //!NOTIFICATIONS
  const text = "voulez-vous supprimer la notification ?";
  const confirm: any = async (id: string) => {
    if (id) {
      await deleteNotifByUser(id);
    }
    if (isSuccess) {
      message.success("Supprimé avec succès");
    } else {
      message.error("Une erreur inconnue est survenue");
    }
  };

  let filterNotifForMsg = dataNotif?.data?.filter(
    (data: any) => data?.type === "messagerie" && data?.seen === false
  );

  let filterNotifForInstaProf = dataNotif?.data?.filter(
    (data: any) => data?.type === "insta_prof" && data?.seen === false
  );

  const resetCount = async () => {
    let result =
      dataNotif?.data?.filter((element: any) => {
        return element?.seen === false;
      }) || [];

    await result?.forEach((element: any) => {
      if (element?._id) {
        viewNotifByUser(element?._id);
      }
    });
  };

  const TEACHER = [
    /* {
      id: 1,
      name: "Accueil",
      icon: ActivitiesIcon,
      link: "/feeds",
      size: 40,
    }, */
    {
      id: 0,
      name: "dashboard",
      icon: Dashboard,
      link: "/teacher/dashboard",
      size: 30,
    },
    {
      id: 1,
      name: "Calendrier",
      icon: CalendarIcon,
      link: "/teacher/calendrier",
      size: 20,
    },
    {
      id: 2,
      name: "Mes Classes",
      icon: Classes,
      link: appRoutes.TEACHER_ROOMS,
      size: 40,
    },
    {
      id: 3,
      name: "Mes Elèves",
      icon: Students,
      link: "/teacher/students",
      size: 40,
    },
  ];

  const teacherMenu = [
    {
      id: 2,
      name: "Portefeuille",
      icon: Wallet,
      link: "#",
      openDrawer: openPorteFeuilleDrawer,
    },
    {
      id: 7,
      name: "Mon contenu",
      icon: Content,
      link: appRoutes.COURSESBYLEVELS,
    },
    {
      id: 8,
      name: "Mes élèves",
      icon: Students,
      link: appRoutes.TEACHER_STUDENTS,
    },
    {
      id: 4,
      name: "Mes calendriers",
      icon: Calendar,
      link: "/teacher/calendrier",
    },
    {
      id: 9,
      name: "Mes classes",
      icon: MyClasses,
      link: "/teacher/rooms",
    },
    {
      id: 10,
      name: "Mes Coupons",
      icon: CouponIcon,
      link: "#",
      openDrawer: openCouponsDrawer,
      iconSize: 30,
    },
    {
      id: 12,
      name: "Guide de démarrage",
      icon: Onboarding,
      link: appRoutes.ONBOARDING,
      iconSize: 30,
    },
    {
      id: 3,
      name: "Gamification",
      icon: Gamification,
      link: appRoutes.TEACHER_GAMIFICATION,
    },
    {
      id: 5,
      name: "FAQ",
      icon: Aide,
      link: appRoutes.FAQ,
    },
    {
      id: 6,
      name: "Contacte-nous",
      icon: Contact,
      link: appRoutes.TEACHER_CONTACT,
    },
  ];

  /* const fetchCalender = useCallback(async (idTeacher: string) => {
    const startDate = new Date().toISOString().split("T")[0];
    try {
      const response: AxiosResponse<CustomResponse> = await axios.get(`${API_RESSOURCES}/advertisements/fetch/ReelCalender/prof/instance/${user?._id}`, {
        params: { startDate },
      });
      if (response.status === StatusCode.OK) {
        if (response?.data?.data) {
          setCalendarAdded(true);
        }
        else {
          setCalendarAdded(false);
        }
      }
      else {
        setCalendarAdded(false);
      }
    } catch (error) {
      setCalendarAdded(false);
    }
  }, [user?._id]); */

  const onAcceptNotifInstaProf = (id: string) => {
    acceptNotificationOfInstaProf(id);
  };

  /* useEffect(() => {
    if(user) {
      fetchCalender(user?._id);
    }
  }, [user]); */

  const showModalInfoInstaProf = () => {
    dispatch(ACTIVE_MODE_INSTAPROF(true));
    dispatch(INIT_MODAL());
  };

  const openMessagerieDrawer = () => {
    dispatch(openChatDrawer());
    dispatch(closeProfileDrawer());
    dispatch(closePorteFeuilleDrawer__());
    setVisible(false);
  };

  const resultPercent = user?.points > 10000 ? 100 : user?.points / 100;

  const closeDrawer = () => {
    dispatch(setCorrectingLevel(false));
    dispatch(closeProfileDrawer());
  };

  const clearCookies = () => {
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/");
    });
  };

  const disconnect = async () => {
    await socket.emit("unsubscribe", user?._id);
    socket?.disconnect();
    closeDrawer();
    dispatch(clearRoom());
    dispatch(clearRooms());
    dispatch(logout());
    clearCookies();
    localStorage.removeItem("couponCode");
    localStorage.clear();
    sessionStorage.clear();
  };

  const setOpenCorrection = () => {
    dispatch(setCorrectingLevel(true));
    openDrawer();
  }

  const setOpenProfile = () => {
    dispatch(setCorrectingLevel(false));
    openDrawer();
  }

  const setCalendar = () => {
    navigate(appRoutes.TEACHER_SET_CALENDAR);
  }

  const handleNavigateToClass = () => {
    dispatch(setCheckClassOrganism(true));
    navigate(appRoutes.TEACHER_ROOMS);
  }

  const content = (
    <div onClick={(e) => e.stopPropagation()} style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
      <div style={{ fontSize: isMobile ? "0.8em" : "13px", cursor: "pointer", display: "flex", flexDirection: "column" }}>
        <span style={{ color: "#80b1b2" }}>{user?.lastname}</span>
      </div>
      <div style={{ height: "1px", width: "90%", margin: "0px auto", background: "#BFBCBC", marginTop: "5px", marginBottom: "5px" }}></div>
      <div onClick={() => { setSeeProfile(true); openDrawer() }} style={{ fontSize: isMobile ? "0.8em" : "12px", color: "#464c4c", cursor: "pointer", display: "flex", flexDirection: "row", borderRadius: "5px", background: "#e5f5f5", alignItems: "center", justifyContent: "center", width: "100%", height: "30px", paddingLeft: "5px", paddingRight: "5px" }}>
        <img src={user?.profile || TeacherProfile} height={15} style={{ marginRight: "5px", borderRadius: "50%" }}></img>
        Mon profil
      </div>
      <Popconfirm
        placement="left"
        title={"Tu confirmes la déconnexion ?"}
        onConfirm={disconnect}
        onCancel={() => setWantDisconnect(false)}
        okText="Oui"
        cancelText="Non"
      >
        <Button onClick={() => setWantDisconnect(true)} style={{ fontSize: isMobile ? "0.8em" : "12px", color: "#f67675", cursor: "pointer", display: "flex", flexDirection: "row", borderRadius: "5px", background: "#ffeae5", alignItems: "center", justifyContent: "center", width: "100%", height: "30px", marginTop: "5px", paddingLeft: "5px", paddingRight: "5px" }}>
          <img src={LogoutIcon} height={15} style={{ marginRight: "5px" }}></img>
          Se déconnecter
        </Button>
      </Popconfirm>
    </div>
  );

  return (
    <Fragment>
      <header className={(isMobile && !user?.isActive) || (isMobile && !userHavingCalendar) || (isMobile && rooms?.data?.length > 0) ? style.headerTeacherInactive : style.headerTeacher}>
        {!user?.isActive && <div className={style.topBar}>
          <div className={style.lottieBox}>
            <LottieAnimation animationData={AnimationData} />
          </div>
          {isMobile ? <div>
            <a style={{ fontSize: "12px", fontWeight: "CartoonFont", color: "white" }}>Ton compte est en cours de validation,</a><br />
            <a style={{ fontSize: "12px", fontWeight: "CartoonFont", color: "white" }}>l’accès aux fonctionnalités est limité</a>
          </div> : <div>Ton compte est en cours de validation, l’accès aux fonctionnalités est limité</div>}
        </div>}
        {user?.step === "completed" && user?.nivMat.length === 0 && <div className={style.topBar}>
          <div className={style.lottieBox}>
            <LottieAnimation animationData={AnimationData} />
          </div>
          {isMobile ? <div>
            <a style={{ fontSize: "12px", fontWeight: "CartoonFont", color: "white" }}>Attention, tu ne peux pas ajouter un contenu,</a><br />
            <a style={{ fontSize: "12px", fontWeight: "CartoonFont", color: "white" }}>ou une classe sans renseigner les niveaux enseignés | <span onClick={setOpenCorrection} style={{ color: "#fff", fontWeight: "bold", textDecoration: "underline", cursor: "pointer" }}>Corriger</span></a>
          </div> : <div>Attention, tu ne peux pas ajouter un contenu, ou une classe sans renseigner les niveaux enseignés. | <span onClick={setOpenCorrection} style={{ color: "#fff", fontWeight: "bold", textDecoration: "underline", cursor: "pointer" }}>Corriger</span></div>}
        </div>}
        {!userHavingCalendar && user?.isActive && <div className={style.topBarCalendar}>
          <div className={style.lottieBox}>
            <LottieAnimation animationData={AnimationData} />
          </div>
          {isMobile ? <div>
            <a style={{ fontSize: "12px", fontWeight: "CartoonFont", color: "white" }}>Tu n’as pas enregistré tes disponibilités.</a><br />
            <a style={{ fontSize: "12px", fontWeight: "CartoonFont", color: "white" }}>Aucun élève ne peut donc réserver de cours avec toi. | <span onClick={setCalendar} style={{ color: "#fff", fontWeight: "bold", textDecoration: "underline", cursor: "pointer" }}>Mon calendrier</span></a>
          </div> : <div>Tu n’as pas enregistré tes disponibilités. Aucun élève ne peut donc réserver de cours avec toi. | <span onClick={setCalendar} style={{ color: "#fff", fontWeight: "bold", textDecoration: "underline", cursor: "pointer" }}>Mon calendrier</span></div>}
        </div>}
        {!isLoadingRooms && rooms?.data?.length > 0 && <div className={style.topBar}>
          <div style={{ textAlign: "center" }}>
            Vous avez une ou plusieurs classe(s) géré(es) par un organisme.
            <span onClick={handleNavigateToClass} style={{ color: "#fff", fontWeight: "bold", textDecoration: "underline", cursor: "pointer", marginLeft: "5px" }}>
              Voir mes cours collectifs
            </span>
          </div>
        </div>}
        <Container>
          <div className={(isMobile && !user?.isActive) || (isMobile && !userHavingCalendar) ? style.menuTeacherInactive : style.menuTeacher}>
            <Link to={UserRoles.TEACHER ? user?.step === "completed" ? "/" : appRoutes.COMPLETE_PROFILE : "/"}>
              <div className={style.logoContainer}>
                <img src={isMobile ? logoMobile : logo} height={50} alt="logo" ></img>
              </div>
            </Link>

            {isMobile && user?.step === "completed" && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", width: "auto", gap: "5px" }}>
              <div /* onClick={() => setOpenMenu(true)} */ style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", height: "50px", width: "80px" }}>
                <Avatar
                  style={{ backgroundColor: "#FFF", border: "1px solid #80b1b2", marginRight: "5px" }}
                  size={35}
                  src={
                    <Image
                      fallback={`http://gravatar.com/avatar${user?.uid}?d=identicon`}
                      preview={false}
                      src={
                        !!user?.profile
                          ? user?.profile
                          : `https://gravatar.com/avatar/${user?._id}?d=identicon`
                      }
                    />
                  }
                >
                  {""}
                </Avatar>
                <Popover
                  visible={visibleOptions}
                  placement="bottom"
                  content={content}
                  trigger="click"
                >
                  <div ref={popoverReportRef} onClick={(e: any) => { e.stopPropagation(); setVisibleOptions(!visibleOptions); }}><img src={visibleOptions ? ArrowUp : ArrowDown} height={17}></img></div>
                </Popover>
              </div>

              {user?.isActive && user?.step === "completed" && <div className={style.notifIcon}>
                <Notification
                  dataNotif={dataNotif}
                  isLoading={isLoading}
                  refetch={refetch}
                />
              </div>}
            </div>}

            {!user?.isActive && user?.step !== "completed" && <div className={style.__logout}>
              <Popconfirm
                placement="left"
                title={"Tu confirmes la déconnexion ?"}
                onConfirm={disconnect}
                okText="Oui"
                cancelText="Non"
              >
                <Button style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", border: "1px solid #FA0000", borderRadius: "12px", fontSize: isMobile ? "0.8em" : "14px", fontWeight: "500", color: "#FA0000" }}>
                  Se déconnecter
                  <LogoutOutlined
                    style={{
                      color: "#FA0000",
                      fontSize: "1.5em",
                      marginTop: "1px"
                    }}
                  />
                </Button>
              </Popconfirm>
            </div>}

            {/* Desktop */}
            {!isMobile && <nav className={style.nav__bar}>
              {user?.step === "completed" && <ul className={`${style.nav__item}`}>
                {TEACHER.map((item, i) => (
                  <li key={i} className={style.__isMobile}>
                    <ul>
                      <li className={style.navbarItemBox}>
                        <Link onClick={() => { item.id === 2 ? dispatch(setCheckClass(true)) : dispatch(setCheckClass(false)) }} to={user?.step !== "completed" ? appRoutes.COMPLETE_PROFILE : item?.link}>
                          {item.id === 4 && bookingCount > 0 && <li style={{ height: 20, width: 20, background: "red", color: "white", borderRadius: "50%", textAlign: "center", position: "relative", top: "10px", right: "-30px", zIndex: "77", display: "flex", alignItems: "center", justifyContent: "center" }}>{bookingCount}</li>}
                          <img
                            src={item.icon}
                            height={item.size}
                            style={{ position: "relative", top: item.id === 4 && bookingCount > 0 ? "-10px" : "0px" }}
                          />

                        </Link>
                      </li>
                      <li>
                        {" "}
                        <NavLink
                          to={user?.step !== "completed" ? appRoutes.COMPLETE_PROFILE : item?.link}
                          className={({ isActive }) =>
                            isActive ? "activeLink" : ""
                          }
                          onClick={() => { item.id === 2 ? dispatch(setCheckClass(true)) : dispatch(setCheckClass(false)) }}
                        >
                          {item.name}
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                ))}

                {user?.instaProf === true && user?.isActive && user?.step === "completed" && !isMobile ? (
                  <Badge
                    className="instaprofBadgeCount"
                    count={
                      filterNotifForInstaProf?.length > 0
                        ? filterNotifForInstaProf?.length
                        : 0
                    }
                    style={{ backgroundColor: "#0BE39B", cursor: "pointer" }}
                  >
                    <li
                      onClick={() => {
                        dispatch(ACTIVE_DRAWER_ALERT_INSTAPROF());
                        // setCheckIfDrawerAllReqIsVisible(true);
                      }}
                      style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start" }}
                    >
                      <Image preview={false} src={instaBadges} width={37} />
                      <span className={style.navInsta}>Instaprof</span>
                    </li>
                  </Badge>
                ) : user?.isActive && user?.step === "completed" ? (
                  <li onClick={() => showModalInfoInstaProf()} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", cursor: "pointer" }}>
                    <Image preview={false} src={instaBadgesRed} width={37} />
                    <span className={style.navInsta} style={{ fontSize: "11px", marginTop: "2.5px" }}>Instaprof</span>
                  </li>
                ) : ('')}

                <li className={`${style.user} ${style.__prof}`} style={{ width: "180px" }}>
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                    <div className={style.albertBox}>
                      <img src={Maa} height={35} />
                    </div>

                    <div
                      className={style.__user__right}
                      onClick={() => setOpen(!open)}
                      style={{ cursor: "pointer" }}
                    >
                      <small className={style.userPointSmall}>
                        {user?.points}{" "}
                        <img
                          src={PointIcon}
                          alt=""
                          width={20}
                          style={{
                            position: "relative",
                            top: "-1px",
                          }}
                        />
                      </small>
                      <div style={{ marginBottom: "3px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "16px" }}>
                        <Col span={3}>
                          <div className={style.cercle}>
                            <img src={Coeur} width={13} />
                          </div>
                        </Col>
                        <Col span={19}>
                          <div className={style.__bar}>
                            <div
                              className={style.progress}
                              style={{
                                width: `${resultPercent}%`,
                              }}
                            />
                          </div>
                        </Col>
                      </div>
                      <span className={style.__frend}>
                        {user?.points > 0 &&
                          user?.points <= 1000 &&
                          "Tu es mon ami"}

                        {user?.points > 1000 &&
                          user?.points <= 5000 &&
                          "Tu es mon grand ami"}

                        {user?.points > 5000 &&
                          user?.points <= 10000 &&
                          "Tu es mon vieile ami"}

                        {user?.points > 10000 && "Tu es mon meilleur ami"}
                      </span>
                    </div>

                    <img
                      src={InfoIcon}
                      alt=""
                      width={11}
                      style={{
                        position: "relative",
                        top: "0px",
                        paddingLeft: "0px",
                        marginLeft: "10px",
                        cursor: "pointer"
                      }}
                      onClick={() => setOpen(!open)}
                    />
                  </div>
                </li>

                <li>
                  <Badge size="small" count={filterNotifForMsg?.length} offset={[-5, 5]}>
                    <div
                      onClick={() => {
                        dispatch(toggleAppChat(true));
                        resetCount();
                      }}
                      className={style.menuBoxMessage}
                      style={{ cursor: "pointer" }}
                    >
                      <div className={style.menuItemBox}>
                        <Image preview={false} src={Msg} width={25} />
                      </div>
                      <span className={style.menuTitle}>Messages</span>
                    </div>
                  </Badge>
                </li>

                {user?.isActive && user?.step === "completed" && <li>
                  <Notification
                    dataNotif={dataNotif}
                    isLoading={isLoading}
                    refetch={refetch}
                  />
                </li>}

                <li className={style.menuBox} onClick={() => setVisible(true)} style={{ marginLeft: "0px", cursor: "pointer" }}>
                  <div className={style.menuItemBox}><Image preview={false} src={MenuIcon} width={25} /></div>
                  <span className={style.menuTitle}>Menu</span>
                </li>

                {!isMobile && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", height: "65px", width: "75px" }}>
                  <img src={user?.profile || TeacherProfile} height={45} style={{ border: "2px solid #80b1b2", borderRadius: "50%" }} />
                  <Popover
                    visible={visibleOptions}
                    placement="bottom"
                    content={content}
                    trigger="click"
                    style={{ height: "70px !important", width: "350px !important", borderRadius: "8px", boxShadow: "4px 8px 16px #8B8B8B38", border: "0.5px solid #BFBCBC", cursor: "pointer" }}
                  >
                    <div ref={popoverReportRef} onClick={(e: any) => { e.stopPropagation(); setVisibleOptions(!visibleOptions); }}><img src={visibleOptions ? ArrowUp : ArrowDown} height={17}></img></div>
                  </Popover>
                </div>}
              </ul>}
            </nav>}
          </div>
        </Container>
      </header>

      <Drawer
        width={isMobile ? "100%" : "40vw"}
        title="teacher Money"
        placement="right"
        onClose={closeMoneyDrawer}
        visible={moneyDrawer}
      >
        <Card>
          <Steps direction="vertical" size="small" current={1}>
            <Step title="Faisons connaissance " description="0 point" />

            <Step title="Mon ami" description="100 points" />
            <Step title="Grand ami" description="500 points" />
            <Step title="Vieil ami " description="1000 points" />
            <Step title="Mon meilleur ami" description="5000 points" />
          </Steps>
        </Card>
      </Drawer>

      <Modal
        destroyOnClose
        footer={null}
        width={isMobile ? "100%" : "40vw"}
        closable={false}
        visible={showVideoModal}
        onCancel={closeVideoModal}
        bodyStyle={{ padding: 0, background: "#000", overflow: "hidden" }}
      >
        <iframe
          width="100%"
          height="400"
          src="https://www.youtube.com/embed/S6jCd2hSVKA?autoplay=1"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Modal>

      <MenuModal
        visible={visible}
        setVisible={setVisible}
        openDrawer={openDrawer}
        openPorteFeuilleDrawer__={openPorteFeuilleDrawer}
      />

      <MAA open={open} setOpen={setOpen} />

      {!currentChat && user?.step === "completed" && !openMenu && (
        <NavUser
          openMessagerieDrawer={openMessagerieDrawer}
          visible={visible}
          setVisible={setVisible}
        />
      )}

      <Drawer
        className="drawer"
        visible={openMenu}
        onClose={() => setOpenMenu(false)}
        placement="left"
        width="85%"
        closable={false}
        bodyStyle={{ padding: 0 }}
        drawerStyle={{
          backgroundColor: "#FFFFFF",
          borderTopRightRadius: "20px",
          borderBottomRightRadius: "20px",
        }}
      >
        {/* HEADER */}
        <div style={{ padding: "20px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <Avatar size={48} src={user?.profile} />
              <div>
                <div style={{ fontWeight: 600, fontSize: "16px" }}>
                  {user?.firstname} {user?.lastname}
                </div>
                <div style={{ fontSize: "12px", color: "#888" }}>
                  Professeur
                </div>
              </div>
            </div>

            <div onClick={() => setOpenMenu(false)} style={{ fontSize: "22px", cursor: "pointer" }}>
              ✕
            </div>
          </div>
        </div>

        <Divider style={{ margin: 0 }} />

        {/* MENU */}
        <div style={{ padding: "10px 0" }}>
          {teacherMenu.map((item) => (
            <Link
              key={item.id}
              to={item.link}
              onClick={() => { item.id === 9 ? dispatch(setCheckClass(true)) : dispatch(setCheckClass(false)); setOpenMenu(false) }}
              style={{ textDecoration: "none" }}
            >
              <div className={style.burgerMenuItem} onClick={item?.openDrawer}>
                <div className={style.burgerMenuLeft}>
                  <div className={style.burgerMenuIcon}>
                    <img src={item.icon} height={item.id === 2 ? 20 : item.id === 4 ? 25 : item.id === 9 ? 25 : item.id === 10 ? 18 : 45} />
                  </div>
                  <span>{item.name}</span>
                </div>

                <span className={style.burgerMenuArrow}>›</span>
              </div>
            </Link>
          ))}
        </div>

        {/* FOOTER */}
        <div className={style.burgerMenuFooter}>
          <Popconfirm
            title="Tu confirmes la déconnexion ?"
            onConfirm={disconnect}
            okText="Oui"
            cancelText="Non"
          >
            <button className={style.logoutBtn}>
              <img src={LogoutIcon} height={16} />
              Se déconnecter
            </button>
          </Popconfirm>
        </div>
      </Drawer>
    </Fragment>
  );
};

export default User;
